export const DiscountReasons = {
  en: {
    'Discount Reasons': 'Discount Reasons',
    'Create Discount Reason': 'Create Discount Reason',
  },
  uk: {
    'Discount Reasons': 'Причини знижки',
    'Create Discount Reason': 'Створити причину знижки',
  },
};

export const DiscountReasonForm = {
  en: {
    ...DiscountReasons.en,
    'New Discount Reason': 'New Discount Reason',
    'Edit Discount Reason': 'Edit Discount Reason',
    'Update Discount Reason': 'Update Discount Reason',
  },
  uk: {
    ...DiscountReasons.uk,
    'New Discount Reason': 'Нова причина знижки',
    'Edit Discount Reason': 'Редагування причини знижки',
    'Update Discount Reason': 'Оновити причину знижки',
  },
};
